export default __webpack_public_path__ + "media/4ed2db1c09f43089d1f47e5832216b403228f8f8928c0d98c96dfee33f5c287e.svg";